import { Icon } from "@iconify/react";
import "../styles/QuoteStatusInfo.css";

function QuoteStatusInfo({ quote }) {
  const getStatusInfo = (status) => {
    const statusMap = {
      awaiting_approval: {
        label: "Aguardando Aprovação",
        icon: "mdi:clock-outline",
        className: "status-pending",
      },
      approved: {
        label: "Aprovada",
        icon: "mdi:check-circle-outline",
        className: "status-completed",
      },
      in_progress: {
        label: "Em Andamento",
        icon: "mdi:progress-clock",
        className: "status-in-progress",
      },
      completed: {
        label: "Concluída",
        icon: "mdi:check-circle-outline",
        className: "status-completed",
      },
      cancelled: {
        label: "Cancelada",
        icon: "mdi:close-circle-outline",
        className: "status-cancelled",
      },
    };

    return statusMap[status] || statusMap.awaiting_approval;
  };

  const statusInfo = getStatusInfo(quote.status);

  return (
    <div className="quote-status-card">
      <div className="quote-status-header">
        <Icon icon="mdi:information-outline" className="card-icon" />
        <h2 className="card-title">Informações da Cotação</h2>
      </div>
      
      <div className="quote-status-content">
        <div className={`status-badge ${statusInfo.className}`}>
          <Icon icon={statusInfo.icon} className="status-icon" />
          <span className="status-label">{statusInfo.label}</span>
        </div>

        <div className="quote-info-grid">
          <div className="quote-info-item">
            <span className="info-label">Tipo de Cliente</span>
            <span className="info-value">{quote.customerType}</span>
          </div>
          
          {quote.totalOffers && (
            <div className="quote-info-item">
              <span className="info-label">Ofertas Recebidas</span>
              <span className="info-value">{quote.totalOffers} de {quote.maximumNumberOffersAllowed}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QuoteStatusInfo;
